/**
 * The KeySystems supported by the playback library.
 *
 * A KeySystem is a packaging of a particular DRM module for the browser's EME
 * API.
 */
export var KeySystem;
(function (KeySystem) {
    /**
     * The Widevine KeySystem.
     *
     * This KeySystem is available primarily in Chrome and Firefox browsers, on
     * Google platforms, and on some TV and hardware platforms.
     */
    KeySystem["WIDEVINE"] = "com.widevine.alpha";
    /**
     * The PlayReady KeySystem.
     *
     * This KeySystem is available primarily on Microsoft browsers and on some TV
     * and hardware platforms.
     */
    KeySystem["PLAYREADY"] = "com.microsoft.playready";
    /**
     * The PlayReady Hardware KeySystem.
     *
     * This is a hardware-accelerated version of the PlayReady KeySystem available
     * on some platforms.
     */
    KeySystem["PLAYREADY_HARDWARE"] = "com.microsoft.playready.hardware";
    /**
     * The FairPlay KeySystem
     *
     * This KeySystem is available primarily on Safari browsers and some Apple
     * platforms.
     */
    KeySystem["FAIRPLAY"] = "com.apple.fps.1_0";
    /**
     * A Test KeySystem.
     *
     * DO NOT USE THIS FOR PRODUCTION APPLICATIONS.
     *
     * This KeySystem is used for test purposes only. There are no actual files
     * associated with this KeySystem.
     */
    KeySystem["INVALID_SPOTIFY_KEY"] = "com.spotify.invalid";
})(KeySystem || (KeySystem = {}));
//# sourceMappingURL=key_system.js.map